<template>
  <div class="payCenter clearfix">
    <div class="container-fluid mainBox">
      <div class="row">
        <div class="col-12 mb-3 mt-4">
          <h4 class="titleBox text-white">
            <b><i class="iconfont icon-gouwuchekong"></i> 结算中心</b>
            <button type="button" class="btn btn-primary btn-lg btn-round d-block d-lg-none">商城 <i class="iconfont icon-more1"></i></button>
          </h4>
        </div>
        <div v-if="type===2 || type===3" class="col-12 text-warning mb-4">
          <i class="iconfont icon-huodong"></i> {{type===2?groupInfo.title:'超级组合，一口价超值 ~'}}
        </div>
        <div class="col-12 mb-2">
          <div class="box">
            <div class="leftBox">
              <div class="chanpinBox mb-3" :class="{'disabledBox':type===2 || type===3}">
                <div class="headBox">
                  <input checked type="radio" value="option1"> 软件，硬件
                </div>
                <ul>
                  <li v-for="(app,index) in goodsArr" :key="index" v-if="!app.song" class="clearfix">
                    <div class="a">
                      <img v-if="app.imgpath" :src="ossImgDomain+app.imgpath">
                      <img v-else src="/static/images/defaultBj.png">
                    </div>
                    <div class="b">
                      <h3>
                        <label v-if="type===1 && app.discountArr.model===2" class="badge badge-danger">直降</label>
                        <label v-if="type===1 && app.discountArr.model===1" class="badge badge-danger">折扣</label>
                        <label v-if="type===1 && app.manjianBool" class="badge badge-warning">满减</label>
                        <label v-if="type===1 && app.zengpinBool" class="badge badge-info">赠</label>
                        <label v-if="type===2" class="badge badge-danger">组合促销</label>
                        <label v-if="type===3" class="badge badge-danger">超级组合</label>
                        {{app.name}}
                      </h3>
                      <span>品牌：{{app.brand_title}}</span>
                    </div>
                    <div class="c">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <button @click="minusGoodsFun(app.id)" :disabled="(type*1)===2 || (type*1)===3" class="btn btn-outline-secondary" type="button">-</button>
                        </div>
                        <input disabled type="text" :value="app.num" class="form-control">
                        <div class="input-group-append">
                          <button @click="addGoodsFun(app.id)" :disabled="(type*1)===2 || (type*1)===3" class="btn btn-outline-secondary" type="button">+</button>
                        </div>
                      </div>
                    </div>
                    <div class="d">
                      <span>￥{{app.final_price}}</span>
                      <p v-if="app.retail_money*1!==app.final_price*1" class="content m-0">￥{{app.retail_money}}</p>
                    </div>
                  </li>
                </ul>
              </div>
              <!--存在送的才会显示送的-->
              <div class="chanpinBox mb-3 disabledBox" v-if="(goodsArr.filter(app=>app.song)).length!==0 || freeSongArr.length!==0">
                <div class="headBox">
                  <input checked type="radio" value="option1">
                  免费的赠品
                </div>
                <!--自由组合-->
                <ul v-if="type === 1">
                  <li v-for="(app,index) in freeSongArr" :key="index" class="clearfix">
                    <div class="a">
                      <img v-if="app.imgpath" :src="ossImgDomain+app.imgpath">
                      <img v-else src="/static/images/defaultBj.png">
                    </div>
                    <div class="b">
                      <h3>{{app.name}}</h3>
                      <span>品牌：{{app.brand_title}}</span>
                    </div>
                    <div class="c">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <button disabled class="btn btn-outline-secondary" type="button">-</button>
                        </div>
                        <input disabled v-model="app.num" type="text" value="1" class="form-control">
                        <div class="input-group-append">
                          <button disabled class="btn btn-outline-secondary" type="button">+</button>
                        </div>
                      </div>
                    </div>
                    <div class="d">
                      <span>￥0</span>
                      <p class="content m-0">￥{{app.retail_money}}</p>
                    </div>
                  </li>
                </ul>
                <!--买赠组合-->
                <ul v-if="type === 2">
                  <li v-for="(app,index) in goodsArr" :key="index" v-if="app.song">
                    <div class="a">
                      <img v-if="app.imgpath" :src="ossImgDomain+app.imgpath">
                      <img v-else src="/static/images/defaultBj.png">
                    </div>
                    <div class="b">
                      <h3>{{app.name}}</h3>
                      <span>品牌：{{app.brand_title}}</span>
                    </div>
                    <div class="c">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <button disabled class="btn btn-outline-secondary" type="button">-</button>
                        </div>
                        <input disabled v-model="app.num" type="text" value="1" class="form-control">
                        <div class="input-group-append">
                          <button disabled class="btn btn-outline-secondary" type="button">+</button>
                        </div>
                      </div>
                    </div>
                    <div class="d">
                      <span>￥0</span>
                      <p class="content m-0">￥{{app.retail_money}}</p>
                    </div>
                  </li>
                </ul>
              </div>

              <!--推荐的加购-->
              <div class="chanpinBox disabledBox" v-if="addCarArr.length >= 1">
                <div class="headBox">
                  <h6>
                    <span class="text-warning"><i class="iconfont icon-jia"></i> 推荐加购</span>
                    <small @click="reloadAddcarFun" class="float-right fudong cursor"><i class="iconfont icon-shuaxin"></i> 换一批</small>
                  </h6>
                </div>
                <!--自由组合-->
                <ul>
                  <li v-for="(app,index) in addCarArr" :key="index" class="clearfix">
                    <div class="a">
                      <img v-if="app.imgpath" :src="ossImgDomain+app.imgpath">
                      <img v-else src="/static/images/defaultBj.png">
                    </div>
                    <div class="b">
                      <h3>{{app.name}}</h3>
                      <span>品牌：{{app.brand_title}}</span>
                    </div>
                    <div class="d text-left">
                      <span>￥{{app.final_price}}</span>
                      <p class="content m-0">￥{{app.retail_money}}</p>
                    </div>
                    <div class="d">
                      <button @click="setAddCarArr(app.id)" class="btn btn-primary btn-sm btn-round"><i class="iconfont icon-jia"></i> 加购</button>
                    </div>
                  </li>
                </ul>
              </div>

              <div class="bottomBox d-none d-lg-block">
                <br>
                <br>
                &nbsp;1. 支付后在《发票管理》内申请发票，激活码及快递在《我的订单》内查看
                <br>
                &nbsp;1. Copyright © 2022 雪帝数字音频有限公司 经营许可证编号：913401000723526976
                <br>
                &nbsp;2. 证照信息 特聘法律顾问：安徽珊瑚谷律师税务所 汤正春
                <br>
                &nbsp;3. 皖ICP备13010146号-6
              </div>
            </div>
            <div class="rightBox pingBox" id="pingBox">
              <div class="dingBox" style="width: 100%;">
                <div class="shouhuoBox mb-3">
                  <h5 class="mb-3">收货信息<i @click="isViewMail=true" class="iconfont icon-xiugai float-right cursor"></i></h5>
                  <div class="mailBox cursor" @click="isViewMail=true">
                    <ul>
                      <li v-if="serialType===2 || serialType===1"><span class="content">邮箱：</span>{{mailEmail?mailEmail:'·····'}}</li>
                      <li v-if="serialType===2 || serialType===0"><span class="content">收件人：</span>{{mailName?mailName:'·····'}}</li>
                      <li v-if="serialType===2 || serialType===0"><span class="content">收件号码：</span>{{mailPhone?mailPhone:'·····'}}</li>
                      <li v-if="serialType===2 || serialType===0"><span class="content">收件地址：</span>{{mailAddress?mailAddress:'·····'}}</li>
                    </ul>
                  </div>
                </div>
                <h3 class="price mb-3 text-danger">
                  <span>￥{{(0>=finallyPrice*1)?0:finallyPrice}}</span>
                  <small class="content">原价：￥{{yuanjiaPrice}}</small>
                </h3>
                <ul v-if="zengpinPrice*1>0 || zhijiangPrice*1>0 || pingtaiPrice*1>0 || manjianPrice*1>0" class="mb-3 discountBox">
                  <li class="text-info" v-if="zengpinPrice*1>0">
                    <div><i class="iconfont icon-zeng"></i> 平台赠品</div>
                    <div>-￥{{zengpinPrice}}</div>
                  </li>
                  <li class="text-danger" v-if="zhijiangPrice*1>0">
                    <div><i class="iconfont icon-cu"></i> 限时直降/折扣</div>
                    <div>-￥{{zhijiangPrice}}</div>
                  </li>
                  <li class="text-primary" v-if="pingtaiPrice*1>0">
                    <div><i class="iconfont icon-cu"></i> {{pingtaiTitle}}</div>
                    <div>-￥{{pingtaiPrice}}</div>
                  </li>
                  <li class="text-warning" v-if="manjianPrice*1>0">
                    <div><i class="iconfont icon-cu"></i> {{manjianTitle}}</div>
                    <div>-￥{{manjianPrice}}</div>
                  </li>
                </ul>
                <div v-if="type===1" class="youhuimaBox mb-3">
                  <h6>优惠代码 <i @click="viewDetailFun(2)" class="iconfont icon-wenhao cursor" style="font-size: 14px;"></i></h6>
                  <div v-if="yhCodeInfo" class="box2">
                    <div>
                      <span><i class="iconfont icon-youhui-copy text-success"></i> {{yhCodeInfo.code}} # {{yhcodeTitle}}</span>
                      <span>-￥{{yhcodePrice}}<i @click="resetYhCodeFun()" class="iconfont iconfont icon-xiugai cursor"></i></span>
                    </div>
                  </div>
                  <div v-if="!yhCodeInfo" class="box">
                    <div class="aa">
                      <input v-model="yhCode" type="text">
                    </div>
                    <div @click="apiApilogincodecollate()" class="bb">
                      <span v-if="!yhCodeLoading">核算</span>
                      <span v-if="yhCodeLoading"><i class="iconfont icon-jiazai xuanzhuan text-white cursor"></i></span>
                    </div>
                  </div>
                </div>
                <div class="youhuimaBox mb-3">
                  <h6>抵扣金 <i @click="viewDetailFun(1)" class="iconfont icon-wenhao cursor" style="font-size: 14px;"></i></h6>
                  <div v-if="dcMoneyInfo" class="box2">
                    <div>
                      <span><i class="iconfont icon-di text-success"></i> 使用抵扣金</span>
                      <span>-￥{{dcMoney}}<i @click="resetDcMoneyFun()" class="iconfont iconfont icon-xiugai"></i></span>
                    </div>
                  </div>
                  <div v-if="!dcMoneyInfo" class="box">
                    <div class="aa">
                      <input @blur="inputPriceFun($event)" v-model="dcMoney" type="text">
                      <span>￥</span>
                    </div>
                    <div @click="apiApilogindcmoneycollate()" class="bb">
                      <span v-if="!dcMoneyLoading">核算</span>
                      <span v-if="dcMoneyLoading"><i class="iconfont icon-jiazai xuanzhuan text-white cursor"></i></span>
                    </div>
                  </div>
                </div>
                <div class="xieyiBox text-right content mb-3">
                  <div class="form-check mb-2">
                    <input v-model="tongyiArr" style="margin-top:1.5px;" class="form-check-input" type="checkbox" value="1" id="defaultCheck1">
                    <label class="form-check-label" for="defaultCheck1">
                      同意<a class="content" target="_blank" href="/about/tiaokuan">《用户协议》</a>
                    </label>
                  </div>
                  <div class="form-check">
                    <input v-model="tongyiArr" style="margin-top:1.5px;" class="form-check-input" type="checkbox" value="2" id="defaultCheck2">
                    <label class="form-check-label" for="defaultCheck2">
                      阅读<a class="content" target="_blank" href="/about/shouhou">《退换货协议》</a>并同意
                    </label>
                  </div>
                </div>
                <div class="text-right">
                  <button @click="payFun()" class="btn btn-danger btn-lg btn-round" :disabled="tongyiArr.length!==2">
                    <i v-if="isCreated" class='iconfont icon-jiazai xuanzhuan'></i>
                    <i v-if="!isCreated" class="iconfont iconfont icon-gouwuchekong"></i>
                    立即支付
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid d-block d-lg-none">
      <div class="row">
        <div class="col-12">
          <div class="bottomBox">
            <br>
            &nbsp;1. 支付后在《发票管理》内申请发票，激活码及快递在《我的订单》内查看
            <br>
            &nbsp;1. Copyright © 2022 雪帝数字音频有限公司 经营许可证编号：913401000723526976
            <br>
            &nbsp;2. 证照信息 特聘法律顾问：安徽珊瑚谷律师税务所 汤正春
            <br>
            &nbsp;3. 皖ICP备13010146号-6
          </div>
        </div>
      </div>
    </div>

    <!--优惠代码，抵扣金说明-->
    <!--收货信息-->
    <div v-if='isViewDetail' @click.self="isViewDetail = false" class="addressBox">
      <div v-if="isViewDetailType===1" class="box">
        <h3>
          当前可用抵扣金：
          <button @click="isViewDetail=false" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span class="text-dark" aria-hidden="true">&times;</span>
          </button>
        </h3>
        <hr>
        <br>
        <br>
        <div class="text-center">
          <span style="font-size: 36px;">￥{{dcMoneyRemainingSum}}</span>
        </div>
        <br>
      </div>
      <div v-if="isViewDetailType===2" class="box">
        <h3>
          优惠代码：
          <button @click="isViewDetail=false" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span class="text-dark" aria-hidden="true">&times;</span>
          </button>
        </h3>
        <hr>
        <br>
        <br>
        <div class="text-center">
          【可联系客服领取优惠代码或关注公众号动态进行获取】
        </div>
        <br>
      </div>
    </div>

    <!--收货信息-->
    <div v-if='isViewMail' class="addressBox">
      <div class="box">
          <h4>
            收货信息
          </h4>
          <hr style="border-color:rgba(0,0,0,0.1);">
          <div v-if="serialType===2 || serialType===1" class="form-group">
            <label>联系邮箱 <span>*</span></label>
            <input type="text" v-model="mailEmail" class="form-control">
          </div>
          <div v-if="serialType===2 || serialType===0" class="form-group">
            <label>收件人 <span>*</span></label>
            <input type="text" v-model="mailName" class="form-control">
          </div>
          <div v-if="serialType===2 || serialType===0" class="form-group">
            <label>收件号码 <span>*</span></label>
            <input type="text" v-model="mailPhone" class="form-control">
          </div>
          <div v-if="serialType===2 || serialType===0" class="form-group">
            <label>收件地址 <span>*</span></label>
            <input type="text" v-model="mailAddress" class="form-control">
          </div>
          <button @click="isViewMail=false" class="btn btn-primary">
            确定
          </button>
      </div>
    </div>

    <!--收货信息-->
    <div v-if='isViewPaybox' class="payBox">
      <div class="jumpSuccessBox" v-if="isJumpSuccess && !isPaySuccess && !isCloseBox">
        <i class='iconfont icon-jiazai xuanzhuan'></i>
        <span>支付中</span>
      </div>
      <div class="paySuccessBox" v-if="isPaySuccess && isPayState*1 === 1 && !isCloseBox">
        <i class="iconfont icon-chenggong text-success"></i>
        <div>支付成功，前往【<router-link tag='span' class="text-primary cursor" to="/ability">我的订单</router-link>】</div>
      </div>
      <div class="paySuccessBox" v-if="isPaySuccess && isPayState*1 === 3 && !isCloseBox">
        <i class="iconfont icon-jinggao text-danger"></i>
        <div>订单已关闭，请刷新重新提交带订单</div>
      </div>
      <div v-if="isCloseBox" class="box text-center">
        <br>
        <br>
        <br>
        <i style="font-size: 46px;" class="iconfont icon-jinggao"></i>
        <br>
        <br>
        <h4>订单已关闭</h4>
        <br>
        <br>
        <i @click="closeViewPayBox()" class="iconfont icon-guanbi close"></i>
      </div>
      <div v-if="!isJumpSuccess && !isPaySuccess && !isCloseBox" class="box">
        <div class="lis mb-3">
            <span @click="checkPatType(1)" class="cursor" :class="{active:pay===1}">
              <img src="/static/images/aliPay.svg">
              支付宝支付
            </span>
            <span @click="checkPatType(2)" class="cursor" :class="{active:pay===2}">
              <img src="/static/images/wechatPay.svg">
              微信支付
            </span>
        </div>
        <div class="mainBoxs">
          <p class="price">
            ￥{{(0>=finallyPrice*1)?0:finallyPrice}}
          </p>
          <span @click="payZhifubaoFun" class="text-primary cursor" v-if="pay===1">支付宝：前往支付宝收银台支付 <i class="iconfont icon-qianwang text-primary cursor"></i></span>
          <img v-if="!makeWechatpayLoading && pay===2" class="zhifuImg img-thumbnail" :src="base64">
          <span v-if="!makeWechatpayLoading && pay===2">【微信支付，扫一扫】</span>
          <div v-if="makeWechatpayLoading && pay===2" class="spinner-border text-secondary mb-3" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div v-if="makeWechatpayLoading && pay===2" class="content">付款码生成中...</div>
        </div>
        <div v-if="orderInfo.dcMoney * 1 !== 0" class="mt-3">
          <small class="content">注释：使用抵扣金￥{{orderInfo.dcMoney}}，如果放弃支付，10分钟后将自动释放或手动在订单中心取消订单~</small>
        </div>
        <i @click="closeViewPayBox()" class="iconfont icon-guanbi close"></i>
      </div>
    </div>
    <br>
  </div>
</template>

<script>

import { EventBus } from '@/util/eventBus';
import resultcommons from '../../util/resultcommons';
import * as types from '@/store/types';
import commons from '../../util/commons';
import generalMix from '@/util/mix/general';
import elementResizeDetectorMaker from 'element-resize-detector';

export default {
  name: 'payCenter',
  props:['token'],
  mixins: [generalMix],
  data () {
    return {
      // 同意复选框
      tongyiArr: [],
      serverInfo:null,
      ossImgDomain: process.env.OSS_IMG_DOMAIN,
      // 收货信息
      mailEmail:'',
      mailName:'',
      mailPhone:'',
      mailAddress:'',
      isViewMail:false,
      // 提示模态框
      isViewDetail:false,
      isViewDetailType:1,
      // 优惠代码
      yhCode:'',
      yhCodeLoading:false,
      yhCodeInfo:null,
      // 抵扣金
      dcMoney:'',
      dcMoneyInfo:null,
      dcMoneyLoading:false,
      dcMoneyRemainingSum:0,
      // 支付框
      isViewPaybox:false,
      pay:1,
      // 组合信息
      groupInfo:{},
      type:1,//1自由2买赠3超级组合
      serialType:0,//0硬件1软件2软硬都有
      // 商品集合
      goodsArr:[],
      manjianArrResult:[],// 满减内容
      pingtaiArrResult:[],// 平台券内容
      // 价格计算
      yuanjiaPrice:0,// 原价
      zongjiaPrice:0,// 未计算 满减 与 平台优惠券 的总价
      chajiaPrice:0,// 直降的优惠力度
      zengpinPrice:0,// 赠品价值
      zhijiangPrice:0,// 直降金额
      manjianPrice:0,// 满减的金额
      manjianTitle:'',// 满减的title
      pingtaiPrice:0,// 平台券的金额
      pingtaiTitle:'',// 平台券标题
      yhcodePrice:0,// 优惠代码优惠价格
      yhcodeTitle:'',// 优惠代码标题
      finallyPrice:0,// 最终的价格
      isCreated:false,
      // 订单详情
      orderInfo:{},
      // 跳转成功
      isJumpSuccess:false,
      // 支付成功
      isPaySuccess:false,
      isPayState: 1,
      // 关闭订单
      isCloseBox: false,
      // 支付根地址
      paymentBaseUrl: process.env.PAYMENT_BASE_URL,
      // 微信二维码生成状态
      makeWechatpayLoading:false,
      base64:'',
      // 加购
      addCarArr:[]
    }
  },
  computed:{
    freeSongArr(){
      if(this.type === 1){
        var arr = [];
        this.goodsArr.forEach(app=>{
          if('songArr' in app){
            app.songArr.forEach(apps=>{
              const info = arr.find(ob=>{
                return ob.id * 1 === apps.id * 1;
              });
              if(info){
                // 存在
                info.num = (info.num * 1) + (apps.num * 1);
              }else{
                // 不存在
                arr.push(JSON.parse(JSON.stringify(apps)));
              }
            });
          }
        });
        return arr;
      }else{
        return [];
      }
    },
    mailBool(){
      let shiwu = false;
      let xuni = false;
      if(this.mailName && this.mailPhone && this.mailAddress){
        shiwu = true
      }
      if(this.mailEmail){
        xuni = true
      }
      if(this.serialType === 0){
        // 实物
        return shiwu;
      }else if(this.serialType === 1){
        // 虚拟序列号
        return xuni;
      }else{
        // 全都有
        return shiwu && xuni;
      }
    }
  },
  methods:{
    closeViewPayBox(){
      this.isViewPaybox = false;
      clearInterval(Window.timerUploadOrder);
      Window.timerUploadOrder = null;
    },
    // 单价
    inputPriceFun(event) {
      const val = event.target.value;
      // 判断金钱
      const amount = val;
      const regex = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
      if (amount !== '') {
        if (!regex.test(amount)) {
          this.dcMoney = '';
          this.dcMoneyInfo = null;
          event.target.value = '';
        } else {
          if(val * 1 > this.dcMoneyRemainingSum * 1){
            this.dcMoney = '';
            this.dcMoneyInfo = null;
            event.target.value = '';
            this.$message.showMsgBox({ type: 'warning', content: '超出抵扣金余额上限' });
          }else{
            this.dcMoney = val;
            this.dcMoneyInfo = null;
            event.target.value = val;
          }
        }
      } else {
        this.dcMoney = '';
        this.dcMoneyInfo = null;
        event.target.value = '';
      }
    },
    // 显示优惠代码和抵扣金描述提示
    viewDetailFun(type) {
      this.isViewDetail = true;
      this.isViewDetailType = type;
    },
    // 抵扣金核销
    apiApilogindcmoneycollate() {
      if(!this.dcMoney){
        this.$message.showMsgBox({ type: 'warning', content: '请填写抵扣金额' });
      }else{
        EventBus.$emit('globalLoadingFun', {bool:true,loading:true});
        this.dcMoneyLoading = true;
        resultcommons.apiApiloginDcmoneycollate(this,{dcMoney:this.dcMoney}).then(app=>{
          if(app.state === 200){
            this.dcMoneyInfo = app.data;
            this.dcMoneyRemainingSum = app.data.cashbackMoney;
          }else{
            this.dcMoney = 0;// 抵扣金
            this.dcMoneyInfo = null;// 抵扣金详情
            this.$message.showMsgBox({ type: 'warning', content: app.message });
          }
          // 自由组合还是 买赠+超级组合
          if(this.type === 2 || this.type === 3){
            this.calculateGroup();
          }else{
            this.calculateFree();
          }
          this.dcMoneyLoading = false;
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
        });
      }
    },
    // 检索优惠代码
    apiApilogincodecollate() {
      if(!this.yhCode){
        this.$message.showMsgBox({ type: 'warning', content: '请填写优惠代码' });
      }else{
        EventBus.$emit('globalLoadingFun', {bool:true,loading:true});
        this.yhCodeLoading = true;
        resultcommons.apiApilogincodecollate(this,{yhCode:this.yhCode}).then(app=>{
          if(app.state === 200){
            this.yhCodeInfo = app.data;
            this.calculateFree();
          }else{
            this.$message.showMsgBox({ type: 'warning', content: app.message });
          }
          this.yhCodeLoading = false;
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
        });
      }
    },
    // 重新填写优惠代码
    resetYhCodeFun() {
      this.yhcodePrice = 0;
      this.yhcodeTitle = '';
      this.yhCodeInfo = null;
      this.yhCode = '';
      this.calculateFree();
    },
    resetDcMoneyFun() {
      this.dcMoney = '';
      this.dcMoneyInfo = null;
      this.calculateFree();
    },
    // 加购操作
    setAddCarArr(goodsID){
      const arr = [];
      this.goodsArr.forEach(app=>{
        arr.push({id:app.id,num:app.num});
      });
      arr.push({id:goodsID,num:1});
      EventBus.$emit('globalLoadingFun', {bool:true,loading:true});
      // 获取新的购物车Token数据
      resultcommons.apiCalculatepaysetaddcar(this,{goodsArr:arr,token:this.token}).then(app=>{
        // 获取最新的Token
        const token = app.data.token;
        resultcommons.apiCalculatepaydata(this,{token}).then(app=>{
          if(app.state === 200){
            // 存储结果
            this.goodsArr = app.data.carInfo;
            // 类型
            this.type = app.data.type * 1;
            if(this.type === 2){
              // 组合详情
              this.groupInfo = app.data.groupInfo;
              // 组合
              this.calculateGroup();
            }else if(this.type === 3){
              // 超级组合
              this.groupInfo = app.data.groupInfo;
              // 组合
              this.calculateGroup();
            }else{
              // 组合
              this.manjianArrResult = app.data.manjianArrResult;// 满减内容
              this.calculateFree();
            }
            // 产品类型
            if(app.data.serialArr.length === 2){
              this.serialType = 2;
            }else{
              this.serialType = app.data.serialArr[0] * 1;
            }
            // 登陆成功
            this.saveLocaluserFun({bool:true});
            // 获取加购内容
            resultcommons.apiCalculatepayaddcar(this,{token}).then(app=>{
              if(app.state === 200){
                this.addCarArr = app.data;
              }
              EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
            });
          }else if(app.state === 202){
            // 非法操作 - 执行跳转
            setTimeout(() => {
              location.href = app.data.url;
            }, 2000);
            this.$message.showMsgBox({ type: 'warning', content: app.message });
          }else{
            this.$message.showMsgBox({ type: 'danger', content: app.message });
          }
        });
      });
    },
    // 减去
    minusGoodsFun(id) {
      var info = this.goodsArr.find(app=>{
        return app.id === id;
      })
      if(info.num * 1 === 1){
        // 直接删除
        this.goodsArr = this.goodsArr.filter(apps=>{
          return apps.id !== id;
        });
      }else{
        // 减1
        info.num = commons.subtrNumber(info.num,1);
        if('songArr' in info){
          info.songArr.forEach(apps=>{
            apps.num = commons.subtrNumber(apps.num,1);
          });
        }
      }
      this.calculateFree();
    },
    addGoodsFun(id) {
      var info = this.goodsArr.find(app=>{
        return app.id === id;
      })
      info.num = commons.accAddNumber(info.num,1);
      if('songArr' in info){
        info.songArr.forEach(apps=>{
          apps.num = commons.accAddNumber(apps.num,1);
        });
      }
      this.calculateFree();
    },
    // 更新订单支付状态
    timerUploadOrder() {
      // 支付成功
      resultcommons.apiOrdercatalogstate(this,{no:this.orderInfo.no}).then(app=>{
        if(app.state === 200){
          if(app.data.state !== '0'){
            if(app.data.state === '3'){
              // 取消预订单
              this.isCloseBox = true;
              clearInterval(Window.timerUploadOrder);
              Window.timerUploadOrder = null;
            }
            if(app.data.state === '1' || app.data.state === '2'){
              this.isPaySuccess = true;
              this.isPayState = app.data.state;
              clearInterval(Window.timerUploadOrder);
              Window.timerUploadOrder = null;
            }
          }else{
            if(this.finallyPrice * 1 !== app.data.price * 1){
              this.finallyPrice = app.data.price;
              if(this.pay === 2){
                this.checkPatType(2);
              }
            }
          }
        }
      });
    },
    // 切换支付
    checkPatType(type) {
      this.pay = type;
      // 如果是微信则请求支付二维码
      if(type === 2) {
        // 微信支付 生成支付二维码
        this.makeWechatpayLoading = true;
        resultcommons.apiWechatpay(this,{no:this.orderInfo.no}).then(app=>{
          if(app.state === 200){
            this.base64 = app.data.base64;
            this.makeWechatpayLoading = false;
            // 创建定时任务
            if(!Window.timerUploadOrder){
              Window.timerUploadOrder = setInterval(() => {
                this.timerUploadOrder();
              }, 500);
            }
          }else{
            this.$message.showMsgBox({
              type: 'warning',
              content: app.message
            });
          }
        });
        // 计算满减优惠
      }else{
        // clearInterval(Window.timerUploadOrder);
      }
    },
    // 支付宝支付
    payZhifubaoFun() {
      // 加载中
      this.isJumpSuccess = true;
      // 创建定时任务
      if(!Window.timerUploadOrder){
        Window.timerUploadOrder = setInterval(() => {
          this.timerUploadOrder();
        }, 500);
      }
      // 执行跳转
      window.open(this.paymentBaseUrl + '/alipay/pagepay.html?no=' + this.orderInfo.no, '_blank');
    },
    // 获取支付订单号信息
    payFun() {
      if(this.tongyiArr.length === 2){
        if(this.mailBool){
          let data = {};
          if(this.type === 2){
            data = {
              token:this.token,
              type:this.type,
              mailInfo:{
                mailEmail:this.mailEmail,
                mailName:this.mailName,
                mailPhone:this.mailPhone,
                mailAddress:this.mailAddress
              },
              priceInfo:{
                yuanjiaPrice:this.yuanjiaPrice,
                zongjiaPrice:this.zongjiaPrice,
                chajiaPrice:this.chajiaPrice,
                zengpinPrice: this.zengpinPrice,
                zhijiangPrice: this.zhijiangPrice,
                manjianPrice:this.manjianPrice,
                pingtaiPrice:this.pingtaiPrice,
                yhcodePrice:this.yhcodePrice,
                yhCode:this.yhCode,
                dcMoney:this.dcMoneyInfo ? this.dcMoney : 0,
                finallyPrice:this.finallyPrice
              },
              goodsArr:this.goodsArr
            };
          }else{
            data = {
              token:this.token,
              type:this.type,
              mailInfo:{
                mailEmail:this.mailEmail,
                mailName:this.mailName,
                mailPhone:this.mailPhone,
                mailAddress:this.mailAddress
              },
              priceInfo:{
                yuanjiaPrice:this.yuanjiaPrice,
                zongjiaPrice:this.zongjiaPrice,
                chajiaPrice:this.chajiaPrice,
                zengpinPrice: this.zengpinPrice,
                zhijiangPrice: this.zhijiangPrice,
                manjianPrice:this.manjianPrice,
                pingtaiPrice:this.pingtaiPrice,
                yhcodePrice:this.yhcodePrice,
                yhCode:this.yhCode,
                dcMoney:this.dcMoneyInfo ? this.dcMoney : 0,
                finallyPrice:this.finallyPrice
              },
              goodsArr:this.goodsArr
            };
          }
          EventBus.$emit('globalLoadingFun', {bool:true,loading:false});
          this.isCreated = true;
          // 传输创建订单
          resultcommons.apiOrdercatalog(this,data).then(app=>{
            if(app.state === 200){
              this.orderInfo = app.data;
              this.isViewPaybox = true;
              this.isCloseBox = false;
              // 立即获取状态
              this.timerUploadOrder();
              // 创建定时任务
              if(!Window.timerUploadOrder){
                Window.timerUploadOrder = setInterval(() => {
                  this.timerUploadOrder();
                }, 500);
              }
            }else{
              window.swal({
                title: app.message,
                icon: 'warning',
                dangerMode: true
              });
            }
            EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
            this.isCreated = false;
          });
        }else{
          // 请填写收货信息
          window.swal({
            title: '无法提交',
            text: '需填写完整的收货信息',
            icon: 'warning',
            dangerMode: true
          });
        }
      }else{
        // 请填写收货信息
        window.swal({
          title: '无法提交',
          text: '请勾选用户协议与退换货协议',
          icon: 'warning',
          dangerMode: true
        });
      }
    },
    calculateFree(){
      // 计算自由组合的价格
      this.yuanjiaPrice = 0;
      this.zongjiaPrice = 0;// 总价格（去除）
      this.chajiaPrice = 0;//
      this.zengpinPrice = 0;// 赠品
      this.zhijiangPrice = 0;// 直降
      this.manjianPrice = 0;// 满减金额
      this.pingtaiPrice = 0;// 平台金额
      // 一口价
      this.goodsArr.forEach(app=>{
        // 原价
        this.yuanjiaPrice = commons.accAddNumber(this.yuanjiaPrice,app.retail_money * app.num);
        if('songArr' in app){
          app.songArr.forEach(apps=>{
            this.yuanjiaPrice = commons.accAddNumber(this.yuanjiaPrice,apps.retail_money * apps.num);
            this.zengpinPrice = commons.accAddNumber(this.zengpinPrice,apps.retail_money * apps.num);
          });
        }
        // 总价
        this.zongjiaPrice = commons.accAddNumber(this.zongjiaPrice,app.final_price * app.num);
      });
      this.chajiaPrice = commons.subtrNumber(this.yuanjiaPrice,this.zongjiaPrice);
      this.zhijiangPrice = commons.subtrNumber(this.chajiaPrice,this.zengpinPrice);
      // 平台券平台券平台券平台券
      if(this.pingtaiArrResult.length !== 0){
        this.pingtaiArrResult.forEach(app=>{
          app.goodsArr = [];
          this.goodsArr.forEach(apps=>{
            if((app.source * 1) === 1){
              // 全部商品
              app.goodsArr.push({id:apps.id,num:apps.num,final_price:apps.final_price});
            }else if((app.source * 1) === 2){
              // 部分商品
              if(app.sourceChild.include){
                // 存在于
                if(app.sourceChild.arr.indexOf(apps.id) !== -1){
                  app.goodsArr.push({id:apps.id,num:apps.num,final_price:apps.final_price});
                }
              }else{
                // 不存在于
                if(app.sourceChild.arr.indexOf(apps.id) === -1){
                  app.goodsArr.push({id:apps.id,num:apps.num,final_price:apps.final_price});
                }
              }
            }else if((app.source * 1) === 3){
              // 全部品牌
              app.goodsArr.push({id:apps.id,num:apps.num,final_price:apps.final_price});
            }else{
              // 部分品牌
              if(app.sourceChild.include){
                // 存在于
                if(app.sourceChild.arr.indexOf(apps.brand_id) !== -1){
                  app.goodsArr.push({id:apps.id,num:apps.num,final_price:apps.final_price});
                }
              }else{
                // 不存在于
                if(app.sourceChild.arr.indexOf(apps.brand_id) === -1){
                  app.goodsArr.push({id:apps.id,num:apps.num,final_price:apps.final_price});
                }
              }
            }
          });
        });
        var pingtaiPriceArr = [0];
        this.pingtaiArrResult.forEach(app=>{
          var money = 0;// 总金额
          var number = 0;// 总个数
          app.goodsArr.forEach(apps=>{
            money = commons.accAddNumber(money,commons.accMulNumber(apps.num,apps.final_price));
            number = commons.accAddNumber(number,apps.num);
          });
          app.allMoney = money;
          app.number = number;
          // 计算能优惠的金额
          if(app.discountsModel === '1'){
            // 满减
            if(money >= app.manMoney * 1){
              pingtaiPriceArr.push(app.money * 1);
              app.youhuiPrice = app.money * 1;
            }
          }else{
            // 满折
            if(number >= app.manMoney * 1){
              pingtaiPriceArr.push(commons.accMulNumber(money,commons.subtrNumber(1,commons.accMulNumber(app.money,0.1))));
              app.youhuiPrice = commons.accMulNumber(money,commons.subtrNumber(1,commons.accMulNumber(app.money,0.1)));
            }
          }
        });
        this.pingtaiPrice = Math.max(...pingtaiPriceArr);
        if(this.pingtaiPrice * 1 === 0){
          this.pingtaiTitle = '';// 优惠title
        }else{
          this.pingtaiTitle = (this.pingtaiArrResult.find(app=>{ return app.youhuiPrice * 1 === this.pingtaiPrice * 1 })).title;// 优惠title
          // 获取最优的优惠券
          var takeInfo = this.pingtaiArrResult.find(app=>{
            return app.youhuiPrice * 1 === this.pingtaiPrice * 1;
          });
          // 开始标记平台券计算过后的单价
          let finalPricePingtaiYouhui = 0;
          takeInfo.goodsArr.forEach(app=>{
            finalPricePingtaiYouhui = commons.divideNumber(commons.divideNumber(commons.accMulNumber(commons.accMulNumber(app.final_price , app.num),takeInfo.youhuiPrice),takeInfo.allMoney),app.num);
            app.final_price_pingtai_youhui = finalPricePingtaiYouhui;
            app.final_price_pingtai = commons.subtrNumber(app.final_price,finalPricePingtaiYouhui);
            const goodsInfo = this.goodsArr.find(apps=>{
              return apps.id * 1 === app.id * 1
            });
            // 定义经过平台券后的价格
            goodsInfo.final_price_pingtai = app.final_price_pingtai;
            goodsInfo.pingtaiArr = {
              pingtaiID:takeInfo.id,
              title:takeInfo.title,
              discountsModel:takeInfo.discountsModel,
              manMoney:takeInfo.manMoney,
              money:takeInfo.money,
              source:takeInfo.source,
              sourceChild:takeInfo.sourceChild,
              final_price:app.final_price,
              final_price_pingtai_youhui:app.final_price_pingtai_youhui,
              final_price_pingtai:app.final_price_pingtai
            };
          });
        }
      }
      // 满减满减满减满减满减满减
      if(this.manjianArrResult.length !== 0){
        this.manjianArrResult.forEach(app=>{
          app.goodsArr = [];
          this.goodsArr.forEach(apps=>{
            let finalPrice = 0;
            if(apps.final_price_pingtai){
              finalPrice = apps.final_price_pingtai;
            }else{
              finalPrice = apps.final_price;
            }
            if((app.source * 1) === 1){
              // 全部商品
              app.goodsArr.push({id:apps.id,num:apps.num,final_price:finalPrice});
            }else if((app.source * 1) === 2){
              // 部分商品
              if(app.sourceChild.include){
                // 存在于
                if(app.sourceChild.arr.indexOf(apps.id) !== -1){
                  app.goodsArr.push({id:apps.id,num:apps.num,final_price:finalPrice});
                }
              }else{
                // 不存在于
                if(app.sourceChild.arr.indexOf(apps.id) === -1){
                  app.goodsArr.push({id:apps.id,num:apps.num,final_price:finalPrice});
                }
              }
            }else if((app.source * 1) === 3){
              // 全部品牌
              app.goodsArr.push({id:apps.id,num:apps.num,final_price:finalPrice});
            }else{
              // 部分品牌
              if(app.sourceChild.include){
                // 存在于
                if(app.sourceChild.arr.indexOf(apps.brand_id) !== -1){
                  app.goodsArr.push({id:apps.id,num:apps.num,final_price:finalPrice});
                }
              }else{
                // 不存在于
                if(app.sourceChild.arr.indexOf(apps.brand_id) === -1){
                  app.goodsArr.push({id:apps.id,num:apps.num,final_price:finalPrice});
                }
              }
            }
          });
        });
        var manjianPriceArr = [0];
        this.manjianArrResult.forEach(app=>{
          var money = 0;
          app.goodsArr.forEach(apps=>{
            money = commons.accAddNumber(money,commons.accMulNumber(apps.num,apps.final_price));
          });
          app.allMoney = money;
          // 计算能优惠的金额 - 循环非循环 如果条件为0则只能一次不能循环
          if(app.manMoney * 1 === 0){
            manjianPriceArr.push(app.money * 1);
            app.youhuiPrice = app.money * 1;
          }else{
            if(app.type * 1 === 1){
              // 循环
              manjianPriceArr.push(commons.accMulNumber(Math.floor(money / app.manMoney),app.money));
              app.youhuiPrice = commons.accMulNumber(Math.floor(money / app.manMoney),app.money);
            }else{
              // 非循环
              if(money >= app.manMoney){
                manjianPriceArr.push(app.money * 1);
                app.youhuiPrice = commons.accMulNumber(app.money * 1);
              }
            }
          }
        });
        this.manjianPrice = Math.max(...manjianPriceArr)
        if(this.manjianPrice * 1 === 0){
          this.manjianTitle = '';
        }else{
          this.manjianTitle = (this.manjianArrResult.find(app=>{ return app.youhuiPrice * 1 === this.manjianPrice * 1 })).title;
          // 获取最优的优惠券
          takeInfo = this.manjianArrResult.find(app=>{
            return app.youhuiPrice * 1 === this.manjianPrice * 1;
          });
          // 开始标记平台券计算过后的单价
          let finalPriceManjianYouhui = 0;
          takeInfo.goodsArr.forEach(app=>{
            finalPriceManjianYouhui = commons.divideNumber(commons.divideNumber(commons.accMulNumber(commons.accMulNumber(app.final_price , app.num),takeInfo.youhuiPrice),takeInfo.allMoney),app.num);
            app.final_price_manjian_youhui = finalPriceManjianYouhui;
            app.final_price_manjian = commons.subtrNumber(app.final_price,finalPriceManjianYouhui);
            const goodsInfo = this.goodsArr.find(apps=>{
              return apps.id * 1 === app.id * 1
            });
            // 定义经过平台券后的价格
            goodsInfo.final_price_manjian = app.final_price_manjian;
            goodsInfo.manjianArr = {
              manjianID:takeInfo.id,
              title:takeInfo.title,
              manMoney:takeInfo.manMoney,
              money:takeInfo.money,
              source:takeInfo.source,
              sourceChild:takeInfo.sourceChild,
              final_price:app.final_price,
              final_price_manjian_youhui:app.final_price_manjian_youhui,
              final_price_manjian:app.final_price_manjian
            };
          });
        }
      }
      // 优惠代码优惠代码优惠代码优惠代码优惠代码
      this.yhcodePrice = 0;
      this.yhcodeTitle = '';
      if(this.yhCodeInfo){
        var yhcodeArrResult = [this.yhCodeInfo];
        yhcodeArrResult.forEach(app=>{
          app.goodsArr = [];
          this.goodsArr.forEach(apps=>{
            let finalPrice = 0;
            if(apps.final_price_manjian){
              finalPrice = apps.final_price_manjian;
            }else if(apps.final_price_pingtai){
              finalPrice = apps.final_price_pingtai;
            }else{
              finalPrice = apps.final_price;
            }
            if((app.source * 1) === 1){
              // 全部商品
              app.goodsArr.push({id:apps.id,num:apps.num,final_price:finalPrice});
            }else if((app.source * 1) === 2){
              // 部分商品
              if(app.sourceChild.include){
                // 存在于
                if(app.sourceChild.arr.indexOf(apps.id) !== -1){
                  app.goodsArr.push({id:apps.id,num:apps.num,final_price:finalPrice});
                }
              }else{
                // 不存在于
                if(app.sourceChild.arr.indexOf(apps.id) === -1){
                  app.goodsArr.push({id:apps.id,num:apps.num,final_price:finalPrice});
                }
              }
            }else if((app.source * 1) === 3){
              // 全部品牌
              app.goodsArr.push({id:apps.id,num:apps.num,final_price:finalPrice});
            }else{
              // 部分品牌
              if(app.sourceChild.include){
                // 存在于
                if(app.sourceChild.arr.indexOf(apps.brand_id) !== -1){
                  app.goodsArr.push({id:apps.id,num:apps.num,final_price:finalPrice});
                }
              }else{
                // 不存在于
                if(app.sourceChild.arr.indexOf(apps.brand_id) === -1){
                  app.goodsArr.push({id:apps.id,num:apps.num,final_price:finalPrice});
                }
              }
            }
          });
        });
        var yhcodePriceArr = [0];
        yhcodeArrResult.forEach(app=>{
          var money = 0;// 总金额
          var number = 0;// 总个数
          app.goodsArr.forEach(apps=>{
            money = commons.accAddNumber(money,commons.accMulNumber(apps.num,apps.final_price));
            number = commons.accAddNumber(number,apps.num);
          });
          app.allMoney = money;
          app.number = number;
          // 计算能优惠的金额
          if(app.discountsModel === '1'){
            // 满减
            if(money >= app.yhMenkan * 1){
              yhcodePriceArr.push(app.yhPrice * 1);
              app.youhuiPrice = app.yhPrice * 1;
            }
          }else{
            // 满折
            if(number >= app.yhMenkanZk * 1){
              yhcodePriceArr.push(commons.accMulNumber(money,commons.subtrNumber(1,commons.accMulNumber(app.yhPriceZk,0.1))));
              app.youhuiPrice = commons.accMulNumber(money,commons.subtrNumber(1,commons.accMulNumber(app.yhPriceZk,0.1)));
            }
          }
        });
        this.yhcodePrice = Math.max(...yhcodePriceArr);
        if(this.yhcodePrice * 1 === 0){
          this.yhcodeTitle = '';// 优惠title
        }else{
          this.yhcodeTitle = (yhcodeArrResult.find(app=>{ return app.youhuiPrice * 1 === this.yhcodePrice * 1 })).title;// 优惠title
          // 获取最优的优惠券
          takeInfo = yhcodeArrResult.find(app=>{
            return app.youhuiPrice * 1 === this.yhcodePrice * 1;
          });
          // 开始标记平台券计算过后的单价
          let finalPriceYhcodeYouhui = 0;
          takeInfo.goodsArr.forEach(app=>{
            finalPriceYhcodeYouhui = commons.divideNumber(commons.divideNumber(commons.accMulNumber(commons.accMulNumber(app.final_price , app.num),takeInfo.youhuiPrice),takeInfo.allMoney),app.num);
            app.final_price_yhcode_youhui = finalPriceYhcodeYouhui;
            app.final_price_yhcode = commons.subtrNumber(app.final_price,finalPriceYhcodeYouhui);
            const goodsInfo = this.goodsArr.find(apps=>{
              return apps.id * 1 === app.id * 1
            });
            // 定义经过平台券后的价格
            goodsInfo.final_price_yhcode = app.final_price_yhcode;
            goodsInfo.yhcodeArr = {
              pingtaiID:takeInfo.id,
              title:takeInfo.title,
              discountsModel:takeInfo.discountsModel,
              yhPrice:takeInfo.yhPrice,
              yhMenkan:takeInfo.yhMenkan,
              yhPriceZk:takeInfo.yhPriceZk,
              yhMenkanZk:takeInfo.yhMenkanZk,
              source:takeInfo.source,
              sourceChild:takeInfo.sourceChild,
              final_price:app.final_price,
              final_price_yhcode_youhui:app.final_price_yhcode_youhui,
              final_price_yhcode:app.final_price_yhcode
            };
          });
        }
      }
      const dcMoney = this.dcMoneyInfo ? this.dcMoney : 0;
      this.finallyPrice = commons.subtrNumber(commons.subtrNumber(commons.subtrNumber(commons.subtrNumber(this.zongjiaPrice,this.manjianPrice),this.pingtaiPrice),this.yhcodePrice),dcMoney);
      this.finallyPrice = this.finallyPrice <= 0 ? 0 : this.finallyPrice;
    },
    calculateGroup(){
      // 一口价
      this.yuanjiaPrice = 0;
      this.zongjiaPrice = 0;
      this.chajiaPrice = 0;
      // 一口价
      this.goodsArr.forEach(app=>{
        // 原价
        this.yuanjiaPrice = commons.accAddNumber(this.yuanjiaPrice,app.retail_money);
        // 总价
        if(this.groupInfo.priceType * 1 === 1){
          // 一口价
          this.zongjiaPrice = this.groupInfo.total_amount;
        }else{
          // 累加
          if(!app.song){
            this.zongjiaPrice = commons.accAddNumber(this.zongjiaPrice,app.final_price);
          }
        }
      });
      this.chajiaPrice = commons.subtrNumber(this.yuanjiaPrice,this.zongjiaPrice);
      this.zhijiangPrice = commons.subtrNumber(this.chajiaPrice,this.zengpinPrice);
      const dcMoney = this.dcMoneyInfo ? this.dcMoney : 0;
      this.finallyPrice = commons.subtrNumber(commons.subtrNumber(commons.subtrNumber(commons.subtrNumber(this.zongjiaPrice,this.manjianPrice),this.pingtaiPrice),this.yhcodePrice),dcMoney);
      this.finallyPrice = this.finallyPrice <= 0 ? 0 : this.finallyPrice;
    },
    reloadAddcarFun(){
      EventBus.$emit('globalLoadingFun', {bool:true,loading:true});
      resultcommons.apiCalculatepayaddcar(this,{token:this.token}).then(app=>{
        if(app.state === 200){
          this.addCarArr = app.data;
        }
        EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
      });
    }
  },
  components: {
  },
  created() {
    EventBus.$emit('globalLoadingFun', {bool:true,loading:true});
    resultcommons.apiCalculatepaydata(this,{token:this.token}).then(app=>{
      this.serverInfo = {
        'yuanjiaPrice':app.data.yuanjiaPrice,
        'zongjiaPrice':app.data.zongjiaPrice,
        'chajiaPrice':app.data.chajiaPrice,
        'zhijiangPrice':app.data.zhijiangPrice,
        'zengpinPrice':app.data.zengpinPrice,
        'manjianPrice':app.data.manjianPrice,
        'pingtaiPrice':app.data.pingtaiPrice,
        'finallyPrice':app.data.finallyPrice
      };
      if(app.state === 200){
        // 登录操作
        let times = 60 * 60 * 24 * 1000;
        // 写入缓存
        app.data.userData.httpHost = app.data.httpHost;
        const result = commons.saveTodos('localUser', app.data.userData, times, 0);
        // 存储结果
        if (result) {
          // 更新本地路由的登录信息
          this.$store.commit(types.SAVE_LOCALUSER, { bool: true });
          // 购物车信息处理
          this.goodsArr = app.data.carInfo;
          // 余额
          this.dcMoneyRemainingSum = app.data.userData.cashbackMoney;
          // 类型
          this.type = app.data.type * 1;
          if(this.type === 2){
            // 组合详情
            this.groupInfo = app.data.groupInfo;
            // 组合
            this.calculateGroup();
          }else if(this.type === 3){
            // 超级组合
            this.groupInfo = app.data.groupInfo;
            // 组合
            this.calculateGroup();
          }else{
            // 组合
            this.manjianArrResult = app.data.manjianArrResult;// 满减内容
            this.pingtaiArrResult = app.data.pingtaiArrResult;// 满减内容
            this.calculateFree();
          }
          // 登录信息
          this.mailName = this.localUser.invoiceInfo.mailName;
          this.mailPhone = this.localUser.invoiceInfo.mailPhone;
          this.mailAddress = this.localUser.invoiceInfo.mailAddress;
          this.mailEmail = this.localUser.email;
          // 产品类型
          if(app.data.serialArr.length === 2){
            this.serialType = 2;
          }else{
            this.serialType = app.data.serialArr[0] * 1;
          }
          // 登陆成功
          this.$message.showMsgBox({ type: 'success', content: '获取成功' });
          this.saveLocaluserFun({bool:true});
          // 获取加购内容
          if(this.type === 1){
            resultcommons.apiCalculatepayaddcar(this,{token:this.token}).then(app=>{
              if(app.state === 200){
                this.addCarArr = app.data;
              }
              EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
            });
          }else{
            EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
          }
        } else {
          // 登陆失败
          this.$message.showMsgBox({ type: 'warning', content: '身份信息错误' });
        }
      }else if(app.state === 202){
        // 非法操作 - 执行跳转
        location.href = app.data.url;
        this.$message.showMsgBox({ type: 'warning', content: app.message });
      }else{
        this.$message.showMsgBox({ type: 'danger', content: app.message });
      }
    });
  },
  mounted() {
    $('.dingBox').pin({
      containerSelector: '.pingBox',
      minWidth: 992
    })
    // 侧边栏
    const _this = this;
    const erd = elementResizeDetectorMaker();
    erd.listenTo($('#pingBox'), element => {
      _this.$nextTick(() => {
        //监听到事件后执行的业务逻辑
        $('.dingBox').pin({
          containerSelector: '.pingBox',
          minWidth: 992,
          padding:{
            top: 80
          }
        })
      });
    });
  },
  destroyed() {
    clearInterval(Window.timerUploadOrder);
    Window.timerUploadOrder = null;
  }
}
</script>

<style scoped lang='less'>
.payCenter {
  min-height: 100%;
  color: #FFFFFF;
  .titleBox{
    font-weight: normal;
    i{
      font-size: inherit;
    }
  }
  div.bottomBox{
    color: rgba(255,255,255,0.4);
    line-height: 1.6em;
  }
  div.addressBox{
    background: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #000000;
    div.box{
      width: 90vw;
      max-width: 660px;
      padding: 30px;
      border-radius: 15px;
      background: #FFFFFF;
      overflow-y: auto;
      span{
        color: #DC3545;
      }
    }
  }
  div.payBox{
    background: rgba(0,0,0,0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    /*flex-direction: column;*/
    justify-content: center;
    align-items: center;
    color: #000000;
    z-index: 9;
    overflow-y: auto;
    i{
      color: #000000;
    }
    div.jumpSuccessBox{
      width: 90vw;
      max-width: 660px;
      padding: 50px 30px;
      border-radius: 15px;
      background: #FFFFFF;
      overflow-y: auto;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      i{
        font-size: 62px;
        margin-bottom: 20px;
      }
    }
    div.paySuccessBox{
      width: 90vw;
      max-width: 660px;
      padding: 50px 30px;
      border-radius: 15px;
      background: #FFFFFF;
      overflow-y: auto;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #000000;
      i{
        font-size: 62px;
        margin-bottom: 20px;
      }
    }
    div.box{
      width: 90vw;
      max-width: 660px;
      padding: 30px;
      border-radius: 15px;
      background: #FFFFFF;
      overflow-y: auto;
      position: relative;
      i.close{
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 36px;
        cursor: pointer;
      }
      div.mainBoxs{
        /*text-align: center;*/
        background: #CCE5FF;
        border: 1px solid #B8DAFF;
        border-radius: 5px;
        padding: 15px;
        p.price{
          font-size: 30px;
          font-weight: bold;
          color: #F51449;
        }
        img.zhifuImg{
          width: 110px;
        }
      }
      div.lis{
        span{
          position: relative;
          margin-right: 5px;
          border-bottom: 0;
          padding: 8px 15px;
          display: inline-block;
          border-radius: 5px;
          color: #000000;
          &.active{
            background: #CCE5FF;
            border: 1px solid #B8DAFF;
            i{
              display: block;
            }
          }
          img{
            height: 18px;
            margin-top: -2px;
          }
          &:last-child{
            margin: 0;
          }
          i{
            display: none;
            color: #28A745;
            position: absolute;
            right: -3px;
            bottom: -4px;
          }
        }
      }
    }
  }
  div.mainBox{
    div.box{
      display: flex;
      div.leftBox{
        margin-right: 20px;
        flex: 1;
        div.chanpinBox{
          background: #2F2F2F;
          border-radius: 6px;
          h3{
            small{
              font-size: 14px;
            }
          }
          div.headBox{
            padding: 15px;
            border-bottom:1px solid rgba(0,0,0,0.6);
          }
          ul{
            li{
              padding: 15px;
              display: flex;
              justify-content: center;
              align-items: center;
              &:last-child{
                border: 0;
              }
              div.a{
                width: 100px;
                height: 60px;
                background: #FFFFFF;
                background-color: #fdfdfd;
                background-image: radial-gradient(circle, #ddd 1px, rgba(0,0,0,0) 1px);
                background-size: 0.8rem 0.8rem;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 20px;
                border: 1px solid #DBDBDB;
                border-radius: 6px;
                img{
                  max-width: 80%;
                  max-height: 80%;
                  border-radius: 2px;
                }
              }
              div.b{
                margin-right: 20px;
                flex: 1;
                h3{
                  font-size: 18px;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                }
              }
              div.c{
                margin-right: 10px;
                width: 120px;
                input{
                  font-weight: bold;
                  text-align: center;
                  background: #FFFFFF;
                  border-color: #FFFFFF;
                }
                .btn{
                  z-index: 0;
                  border-color: #FFFFFF;
                  background: #FFFFFF;
                  color: #000000;
                  font-weight: bold;
                }
              }
              div.d{
                width: 150px;
                text-align: right;
                font-size: 18px;
                color: #F51449;
                span{
                  font-weight: bold;
                  font-size: 20px;
                }
                p{
                  color: #999999;
                  font-size: 16px;
                  &:last-child{
                    text-decoration: line-through;
                  }
                }
              }
            }
          }
          &.disabledBox{
            ul{
              li{
                div.c{
                  button{
                    background: #E9ECEF !important;
                    border: 0;
                    color: rgba(0,0,0,0.6);
                  }
                  input{
                    background: #A7A9AB !important;
                    border: 0;
                  }
                  .input-group-append{
                    margin: 0;
                  }
                }
              }
            }
          }
        }
      }
      div.rightBox{
        width: 360px;
        padding-right: 30px;
        color: #ffffff;
        span.zhifu{
          background: #343A40;
          border: 0;
        }
        h3.price{
          color: #F51449;
          text-align: right;
          font-size: 36px;
          small{
            font-size: 0.4em;
            color: #999999;
            font-weight: bold;
            text-decoration: line-through;
            display: block;
            line-height: 25px;
          }
        }
        span.yuanjiaPrice{
          font-size: 16px;
          text-decoration: line-through;
          font-weight: bold;
        }
        ul.discountBox{
          li{
            display: flex;
            line-height: 1.8em;
            font-size: 12px;
            div{
              &:first-child{
                flex: 1;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                i{
                  font-size: 12px;
                }
              }
              &:last-child{
                width: 100px;
                text-align: right;
              }
            }
          }
        }
        div.youhuimaBox{
          h6{
            margin-bottom: 10px;
          }
          div.box2{
            font-size: 12px;
            line-height: 1.8em;
            div:first-child{
              display: flex;
              span{
                display: block;
                &:first-child{
                  -webkit-box-flex: 1;
                  -ms-flex: 1;
                  flex: 1;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  color: #999999;
                  i{
                    font-size: 13px;
                  }
                }
                &:last-child{
                  width: 100px;
                  text-align: right;
                  color: #FFFFFF;
                  i{
                    font-size: 12px;
                    margin-left: 5px;
                  }
                }
              }
            }
            div:last-child{
              color: #999999;
            }
          }
          div.box{
            display: flex;
            div.aa{
              flex: 1;
              margin-right: 20px;
              position: relative;
              input{
                line-height: 38px;
                width: 100%;
                background: rgba(255,255,255,0.1);
                padding: 0 15px;
                border-radius: 25px;
                border: 2px solid rgba(255,255,255,0.15);
                color: #999999;
                &:hover{
                  background: rgba(255,255,255,0.15);
                }
              }
              span{
                position: absolute;
                top: 5px;
                bottom: 5px;
                right: 5px;
                width: 32px;
                border: 1p solid #CCCCCC;
                background: rgba(255,255,255,0.1);
                display: block;
                border-radius: 50%;
                text-align: center;
                line-height: 32px;
              }
            }
            div.bb{
              span{
                text-align: center;
                line-height: 38px;
                height: 42px;
                width: 70px;
                display: inline-block;
                background: rgba(255,255,255,0.1);
                border-radius: 35px;
                cursor: pointer;
                font-size: 12px;
                color: #999999;
                border: 2px solid rgba(255,255,255,0.15);
                &:hover{
                  background: rgba(255,255,255,0.15);
                  color: #CCCCCC;
                }
                i{
                  font-size: 12px;
                }
              }
            }
          }
        }
        div.mailBox{
          background: rgba(255,255,255,0.1);
          padding: 20px;
          border-radius: 10px;
          border: 2px solid rgba(255,255,255,0.2);
          span{
            display: inline-block;
          }
          &:hover{
            background: rgba(255,255,255,0.15);
          }
        }
        div.xieyiBox{
          font-size: 12px;
        }
        div.beizhu{
          span{
            display: block;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
      }
    }

  }

}

@media (max-width: 1200px) {
  .payCenter {
    div.mainBox {
      div.box {
        div.rightBox{
          width: 300px;
          padding-right: 20px;
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .payCenter{
    .titleBox{
      display: flex;
      justify-content: space-between;
    }
    div.mainBox {
      div.box{
        flex-direction: column;
        div.leftBox{
          margin: 0;
          margin-bottom: 15px;
        }
        div.rightBox{
          width: 100%;
          background: rgba(0,0,0,0.3);
          padding: 15px;
          border-radius: 15px;
          border: 0;
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .payCenter{
  }
  .payCenter {
    div.mainBox {
      div.box {
        div.leftBox {
          div.chanpinBox {
            ul {
              li{
                display: block;
                div.a,div.b,div.c,div.d{
                  float: left;
                  width: 50%;
                  margin: 0;
                }
                div.a,div.b{
                  height: 85px;
                  margin-bottom: 10px;
                }
                div.b{
                  padding-left: 10px;
                  display: flex;
                  flex-direction: column;
                  h3{
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    border-bottom: 0;
                    font-size: 16px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pay/Center.vue